module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/waku-waku-1-d4e217059a72d400ced9def781cb0a16.jpg";